import { ChildrenModelBase } from "./children-base.model";

export class QuestionType extends ChildrenModelBase {
  description: string;
}
